import { loadEmblaCarousel } from '../util/load-dependencies';
import EmblaAutoplay from '../util/embla/autoplay';
import SiteEvents, { SiteEventNames } from '../util/site-events';

class BannerSlider {
    constructor(el) {
        this.el = el;
        this.emblaInstances = [];
        this.initializeEmbla();
    }

    initializeEmbla = async () => {
        try {
            const EmblaCarousel = await loadEmblaCarousel();
            const emblaContainerEls = this.el.querySelectorAll('.embla-instance');
            
            Array.from(emblaContainerEls).forEach((emblaRootEl) => {
                const emblaEl = emblaRootEl.querySelector('.embla');

                const transitionSpeed = emblaRootEl
                    ? parseInt(emblaRootEl.getAttribute('data-transition-speed') || 10, 10)
                    : 10;

                const enableAutoplay = emblaRootEl
                    ? parseInt(emblaRootEl.getAttribute('data-enable-autoplay') || 0, 10)
                    : 1;

                const autoplaySpeed = emblaRootEl
                    ? parseInt(emblaRootEl.getAttribute('data-autoplay-speed') || 3000, 10)
                    : 3000;

                const instance = {
                    embla: EmblaCarousel(emblaEl, {
                        loop: true,
                        speed: transitionSpeed
                    }),
                    pagination: null,
                    autoplay: null
                };


                if (instance.embla) {
                    instance.embla.on('init', () => {
                        SiteEvents.publish(SiteEventNames.IMAGEBUDDY_TRIGGER_UPDATE);
                    });

                    if (enableAutoplay && autoplaySpeed) {
                        instance.autoplay = new EmblaAutoplay(instance.embla, autoplaySpeed);
                    }

                    this.emblaInstances.push(instance);


                }
            });
        } catch (err) {
            console.error('Embla Carousel dynamic import failed', err);
        }
    };
}

export default BannerSlider;